module.exports = __webpack_public_path__ + "img/dentsu-pix.83ee62b1.jpg";